<template>
  <div class="button" @click="getArea">
    <a-icon type="pushpin" style="font-size: 18px" />
    <div>{{ isGettingArea ? "结束拾取" : "获取面积" }}</div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("mapTools", ["isGettingArea", "selectedLnglat"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setIsGettingArea", "setSelectedLnglat"]),

    getArea() {
      if (!this.isGettingArea) {
        this.$message.info("请点击地图");
        this.setSelectedLnglat([]); // reset data
        this.setIsGettingArea(true);
      } else {
        if (this.selectedLnglat.length > 2) {
          if (window.AMap) {
            const area = window.AMap.GeometryUtil.ringArea([
              ...this.selectedLnglat.map((item) => [item.lng, item.lat]),
            ]);
            alert(
              `${this.selectedLnglat.length}个点组成的面积为${Math.round(
                area
              ).toLocaleString()}平方米（${Math.round(
                area / 1000000
              ).toLocaleString()}平方千米）`
            );
            this.setSelectedLnglat([]); // reset data
            this.setIsGettingArea(false);
          }
        } else {
          this.$message.error("测量面积需至少三个点");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}
</style>